import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './app/App';

import 'bootstrap/dist/css/bootstrap.css';
import './index.css';

import 'bootstrap/dist/js/bootstrap.js';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <App />
  </React.StrictMode>
);

